import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DrBadgeNewComponent, ImgPipe } from '@datarailsshared/datarailsshared';
import { ShellComponent } from './shell/shell.component';
import { HeaderComponent } from './header/header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { SessionExpiredLandingComponent } from './session-expired-landing/session-expired-landing.component';
import { UnauthenticatedLandingComponent } from './unauthenticated-landing/unauthenticated-landing.component';

@NgModule({
    declarations: [ShellComponent, HeaderComponent, SideNavComponent],
    imports: [
        CommonModule,
        RouterModule,
        DrBadgeNewComponent,
        ImgPipe,
        SessionExpiredLandingComponent,
        UnauthenticatedLandingComponent,
    ],
    exports: [ShellComponent],
})
export class LayoutModule {}
